import { useMutation } from 'common/hooks';
import { verifyCompanySubUrlApi } from '../companies.service';

export const useVerifyCompanySubUrl = () => {
  const mutationResponse = useMutation(verifyCompanySubUrlApi, {
    showErrorSnackbar: false,
  });
  return mutationResponse;
};
